export const TEXT_COLORS = [
    { label: 'Black', value: '#000000' },
    { label: 'Red', value: '#ff0000' },
    { label: 'Green', value: '#008000' },
    { label: 'Blue', value: '#0000ff' },
    { label: 'Orange', value: '#ffa500' },
    { label: 'Purple', value: '#800080' },
];

export const HIGHLIGHT_COLORS = [
    { label: 'None', value: '' },
    { label: 'Yellow', value: '#ffff00' },
    { label: 'Cyan', value: '#00ffff' },
    { label: 'Pink', value: '#ffc0cb' },
    { label: 'Light Gray', value: '#f0f0f0' },
];

export const FONT_SIZES = [
    '8pt',
    '9pt',
    '10pt',
    '11pt',
    '12pt',
    '14pt',
    '16pt',
    '18pt',
    '20pt',
    '24pt',
    '28pt',
    '32pt',
];
